import React from 'react';

import Item from './Item';
import Dl from './Dl';

const ShrinkItem = React.forwardRef(function ShrinkItem(
  {
    primary,
    flexShrink,
    flexBasis,
    actualSize,
    shrunkBy,
    layout = false,
  },
  ref
) {
  return (
    <Item
      ref={ref}
      style={{ flexShrink, flexBasis }}
      wrapperStyle={{
        paddingLeft: 4,
        paddingRight: 4,
      }}
      primary={primary}
      layout={layout}
      textWrapperStyle={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        height: '100%',
      }}
    >
      <Dl>
        <dt data-prop>flex-basis</dt>
        <dd>{flexBasis}px</dd>
        {typeof flexShrink === 'number' && (
          <>
            <dt data-prop>flex-shrink</dt>
            <dd>{flexShrink}</dd>
          </>
        )}
        {typeof actualSize === 'number' && (
          <>
            <dt>Actual size:</dt>
            <dd>{Math.round(actualSize)}px</dd>
          </>
        )}

        <dt style={{ opacity: shrunkBy ? 1 : 0 }}>Reduced by:</dt>
        <dd style={{ opacity: shrunkBy ? 1 : 0 }}>{shrunkBy}%</dd>
      </Dl>
    </Item>
  );
});

export default ShrinkItem;
